import React, { useState, useEffect } from "react";
import { getLoggedInUser, updateAdmin } from "../../utils/helper";
import Loader from "../../utils/Loader";
import avatar from "../../assets/img/profile_av.jpg";
import { alertSuccess, alertError } from "../../utils/alerts";
import { states } from "../../utils/dataFile";

const INIT_DETAILS = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    status: "",
    address: "",
    marital_status: "single",
    date_of_birth: "",

    branch: "",
    organization: "",
    department: "",
    staff_id: "",
    hire_date: "",
    job_role: "",

    personal_email: "",
    personal_phone: "",
    residential_address: "",
    town_address: "",
    state_address: "",
    country_address: "",

    pfa_name: "",
    pfa_account: "",
    pfa_pin: "",
    etcc_pin: "",

    bank_name: "",
    bank_address: "",
    account_type: "",
    account_number: "",

    nok_name: "",
    nok_phone: "",
    nok_address: "",
    nok_relationship: "",

    qualification_institution: "",
    qualification_qualification: "",
    qualification_field: "",
    qualification_grade: "",
    qualification_start: null,
    qualification_end: null,


    reference_name: "",
    reference_address: "",

    qualifications: [],
};

export default function MyProfile() {    
    const [loading, setLoading] = useState(false);
    // const history = useHistory();
    const TOKEN = localStorage.getItem("kloka:token:data");
    const [profile, setEmployee] = useState(null);

    const [details, setDetails] = useState(INIT_DETAILS);
    // const [state, setState] = useState(INIT_STATE);    

    useEffect(() => {
        setLoading(true)
        getLoggedInUser(TOKEN)
            .then((res) => { 
                setEmployee(res.data.data); setLoading(false) }
            ).catch((err) => { 
                console.log(err.response); setLoading(false); }
            );
    }, [TOKEN]);

    const handleChange = (e) => {
        e.persist();
        setDetails((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        setDetails((prev) => ({
            ...prev,
            id: (profile && profile._id) || "",
            first_name: (profile && profile.first_name) || "",
            last_name: (profile && profile.last_name) || "",
            middle_name: (profile && profile.middle_name) || "",
            status: (profile && profile.status) || "",
            email: (profile && profile.email) || "",
            phone: (profile && profile.phone) || "",
            profile_pic: (profile && profile.profile_pic) || "",
            
            organization: (profile && profile.organization) || "",
            branch: (profile && profile.branch) || "",
            department: (profile && profile.department) || "",
            staff_id: (profile && profile.staff_id) || "",
            job_role: (profile && profile.job_role) || "",
            hire_date: (profile && profile.hire_date) || "",
            hire_month: (profile && profile.hire_month) || "",
            hire_year: (profile && profile.hire_year) || "",
            
            personal_email: (profile && profile.personal_email) || "",
            personal_phone: (profile && profile.personal_phone) || "",
            residential_address: (profile && profile.residential_address) || "",
            gender: (profile && profile.gender) || "",
            marital_status: (profile && profile.marital_status) || "single",
            date_of_birth: (profile && profile.date_of_birth) || "",
            state_of_origin: (profile && profile.state_of_origin) || "",
            nationality: (profile && profile.nationality) || "nigerian",

            pfa_name: (profile && profile.pfa_name) || "",
            pfa_account: (profile && profile.pfa_account) || "",
            pfa_pin: (profile && profile.pfa_pin) || "",
            etcc_pin: (profile && profile.etcc_pin) || "",
            bank_name: (profile && profile.bank_name) || "",
            bank_address: (profile && profile.bank_address) || "",
            account_type: (profile && profile.account_type) || "",
            account_number: (profile && profile.account_number) || "",

            qualifications: (profile && profile.qualifications) || [],

            nok_name: (profile && profile.nok_name) || "",
            nok_phone: (profile && profile.nok_phone) || "",
            nok_address: (profile && profile.nok_address) || "",
            nok_relationship: (profile && profile.nok_relationship) || "",

            reference_name: (profile && profile.reference_name) || "",
            reference_address: (profile && profile.reference_address) || "",

            employer_name: (profile && profile.employer_name) || "",
            employer_address: (profile && profile.employer_address) || "",
            employer_country: (profile && profile.employer_country) || "",
            employer_start: (profile && profile.employer_start) || "",
            employer_end: (profile && profile.employer_end) || "",

            // qualification_start: moment(qualStartDate).format('YYYY'),
            // qualification_end: moment(qualEndDate).format('YYYY'),
        }));
    }, [profile]);

    const handleUpdatePersonal = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const { personal_email, personal_phone, residential_address, date_of_birth, state_of_origin, nationality, gender, marital_status } = details;
            const data = { personal_email, personal_phone, residential_address, date_of_birth, state_of_origin, nationality, gender, marital_status };
            if(data.personal_email && data.personal_phone && data.residential_address && data.date_of_birth && data.state_of_origin &&
                data.nationality && data.gender && data.marital_status
            ){
                setLoading(true);
                updateAdmin(data, details.id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                });
            };
        } else {alert("Personal information update was canceled!");}
    }

    const handleUpdateBank = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const { bank_name, bank_address, account_number, account_type, etcc_pin, pfa_name, pfa_account, pfa_pin } = details;
            const data = { bank_name, bank_address, account_number, account_type, etcc_pin, pfa_name, pfa_account, pfa_pin };
            if(data.bank_name && data.bank_address && data.account_number && data.account_type && data.pfa_name && data.pfa_account && data.pfa_pin){
                setLoading(true);
                updateAdmin(data, details.id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                });
            };
        } else {alert("Bank information update was canceled!");}
    }

    const handleUpdateNOK = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const { nok_name, nok_relationship, nok_address, nok_phone } = details;
            const data = { nok_name, nok_relationship, nok_address, nok_phone };
            if(data.nok_name && data.nok_relationship && data.nok_phone && data.nok_address){
                setLoading(true);
                updateAdmin(data, details.id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                });
            };
        } else {alert("Next of Kin information update was canceled!");}
    }

    const handleUpdateRef = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const { reference_address, reference_name } = details;
            const data = { reference_address, reference_name };
            if(data.reference_address && data.reference_name){
                setLoading(true);
                updateAdmin(data, details.id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                });
            };
        } else {alert("Guarantor/Reference information update was canceled!");}
    }

    const isCanEdit = profile && details ? profile.status && ((profile._id === details.id)) : false;

    // const navigateById = (path, id) => {
    //     history.push(`${path}/${id}`);
    // };

    return (
        <>
            <h1 className="dash-title">Profile Management</h1>

            {loading ? <Loader /> : 
                <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="profile-view">
                                <div className="profile-img-wrap">
                                    <div className="profile-img">
                                        <img 
                                            src={(details && (details.profile_pic !== "")) ? details.profile_pic : avatar} 
                                            alt="avatar" 
                                        />
                                    </div>
                                </div>
                            
                                <div className="profile-basic">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="profile-info-left">
                                                <h3 className="user-name m-t-0 mb-0 text-capitalize">{details.first_name} {details.last_name} </h3>
                                                <h6 className="text-muted">{details.job_role && details.job_role?.name}</h6>
                                                <small className="text-muted"></small>
                                                <div className="staff-id">Department: {details.department && details.department?.name}</div>
                                                <div className="staff-id">Employee ID: {details.staff_id ? details.staff_id : "KR-FT-1009"} </div>
                                                <div className="staff-id small doj text-muted">Hire Year: {details.hire_year ? details.hire_year 
                                                : "2024"} </div>
                                                <div className="staff-id small doj text-muted">Hire Month: {details.hire_month ? details.hire_month 
                                                : "January"} </div>
                                                <div className="staff-id small doj text-muted">Hire Date: {details.hire_date ? details.hire_date 
                                                : "1st"} </div>
                                            </div>
                                        </div>
                                        <div className="col-md-7">
                                            <ul className="personal-info">
                                                <li>
                                                    <div className="title">Organization:</div>
                                                    <div className="text">{details.organization && details.organization?.name}</div>
                                                </li>
                                                <li>
                                                    <div className="title">Work Phone:</div>
                                                    <div className="text"><span>{details.phone} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Work Email:</div>
                                                    <div className="text"><span>{details.email} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Department:</div>
                                                    <div className="text">{details.department && details.department?.name}</div>
                                                </li>
                                                <li>
                                                    <div className="title">Branch:</div>
                                                    <div className="text">{details.branch && details.branch?.branch_name} </div>
                                                </li>
                                                <li>
                                                    <div className="title">Staff ID:</div>
                                                    <div className="text">{details.staff_id && details.staff_id} </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Personal Details 
                                <button type="button" data-toggle="modal" data-target="#personalModal" className="edit-icon pull-right">
                                    <i className="fa fa-solid fa-pencil"></i>
                                </button>
                            </h3>
                            <ul className="personal-info">
                                <li>
                                    <div className="title">Personal Email:</div>
                                    <div className="text">{details.personal_email && details.personal_email}</div>
                                </li>
                                <li>
                                    <div className="title">Personal Phone:</div>
                                    <div className="text">{details.personal_phone && details.personal_phone}</div>
                                </li>
                                <li>
                                    <div className="title">Birthday:</div>
                                    <div className="text"><span>{details.date_of_birth} </span></div>
                                </li>
                                <li>
                                    <div className="title">Residential Address:</div>
                                    <div className="text">{details.residential_address && details.residential_address}</div>
                                </li>
                                <li>
                                    <div className="title">State of Origin:</div>
                                    <div className="text">{details.state_of_origin && details.state_of_origin} </div>
                                </li>
                                <li>
                                    <div className="title">Nationality:</div>
                                    <div className="text">{details.nationality && details.nationality}</div>
                                </li>
                                <li>
                                    <div className="title">Marital Status:</div>
                                    <div className="text">{details.marital_status && details.marital_status}</div>
                                </li>
                                <li>
                                    <div className="title">Gender:</div>
                                    <div className="text">{details.gender && details.gender}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Bank Information 
                                <button type="button" data-toggle="modal" data-target="#bankModal" className="edit-icon pull-right">
                                    <i className="fa fa-solid fa-pencil"></i>
                                </button>
                            </h3>
                            
                            <ul className="personal-info">
                                <li>
                                    <div className="title">Bank name</div>
                                    <div className="text">{details.bank_name && details.bank_name}</div>
                                </li>
                                <li>
                                    <div className="title">Bank account No.</div>
                                    <div className="text">{details.account_number && details.account_number}</div>
                                </li>
                                <li>
                                    <div className="title">Bank Account Type:</div>
                                    <div className="text">{details.account_type && details.account_type}</div>
                                </li>
                                <li>
                                    <div className="title">Bank Branch:</div>
                                    <div className="text">{details.bank_address && details.bank_address}</div>
                                </li>
                                <li>
                                    <div className="title">ETCC PIN:</div>
                                    <div className="text">{details.etcc_pin && details.etcc_pin}</div>
                                </li>
                                <li>
                                    <div className="title">Pension Fund Administrator:</div>
                                    <div className="text">{details.pfa_name && details.pfa_name}</div>
                                </li>
                                <li>
                                    <div className="title">PFA Account Number:</div>
                                    <div className="text">{details.pfa_account && details.pfa_account}</div>
                                </li>
                                <li>
                                    <div className="title">PFA PIN:</div>
                                    <div className="text">{details.pfa_pin && details.pfa_pin}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Next of Kin Information 
                                <button type="button" data-toggle="modal" data-target="#nokModal" className="edit-icon pull-right">
                                    <i className="fa fa-solid fa-plus"></i>
                                </button>
                            </h3>
                            {(details.nok_name && details.nok_address && details.nok_phone) ? 
                            <div className="table-responsive">
                                <table className="table table-bordered table-stripped">
                                    <thead><tr><th>Name</th><th>Relationship</th><th>Address</th><th>Phone</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>{details.nok_name && details.nok_name}</td>
                                            <td>{details.nok_relationship && details.nok_relationship}</td>
                                            <td>{details.nok_address && details.nok_address}</td>
                                            <td>{details.nok_phone && details.nok_phone}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>: null}
                        </div>
                    </div>
                </div>

                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Guarantor Information 
                                <button type="button" data-toggle="modal" data-target="#refModal" className="edit-icon pull-right">
                                    <i className="fa fa-solid fa-plus"></i>
                                </button>
                            </h3>
                            {(details.reference_name && details.reference_address) ? 
                            <div className="table-responsive">
                                <table className="table table-nowrap table-bordered table-stripped">
                                    <thead><tr><th>Reference Name</th><th>Reference Address</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>{details.reference_name && details.reference_name}</td>
                                            <td>{details.reference_address && details.reference_address}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> : null }
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="row">
                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Education Information 
                                <Link to="/profile" className="edit-icon"><i className="fa fa-solid fa-pencil"></i></Link>
                            </h3> */}
                            {/* <div className="experience-box">
                                <ul className="experience-list">
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">International College of Arts and Science (UG)</a>
                                                <div>Bsc Computer Science</div>
                                                <span className="time">2000 - 2003</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">International College of Arts and Science (PG)</a>
                                                <div>Msc Computer Science</div>
                                                <span className="time">2000 - 2003</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div> */}
                        {/* </div>
                    </div>
                </div> */}

                {/* <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body"> 
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Experience 
                                <Link href="/profile" className="edit-icon"><i className="fa fa-solid fa-pencil"></i></Link>
                            </h3> */}
                            {/* <div className="experience-box">
                                <ul className="experience-list">
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">Web Designer at Zen Corporation</a>
                                                <span className="time">Jan 2013 - Present (5 years 2 months)</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">Web Designer at Ron-tech</a>
                                                <span className="time">Jan 2013 - Present (5 years 2 months)</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">Web Designer at Dalt Technology</a>
                                                <span className="time">Jan 2013 - Present (5 years 2 months)</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div> */}
                        {/* </div>
                    </div>
                </div>
            </div> */}

            
            <div id="personalModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">UPDATE PERSONAL DETAILS</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Personal Email <span>*</span></label>
                                    <input type="text" name="personal_email" className="form-control" required placeholder="Personal Email" 
                                    onChange={handleChange} defaultValue={details.personal_email && details.personal_email }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Personal Phone <span>*</span></label>
                                    <input type="text" name="personal_phone" className="form-control" required placeholder="Personal Phone" 
                                    onChange={handleChange} defaultValue={details.personal_phone && details.personal_phone }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Residential Address <span>*</span></label>
                                    <input type="text" name="residential_address" className="form-control" required placeholder="Residential Address" 
                                    onChange={handleChange} defaultValue={details.residential_address && details.residential_address }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Date of Birth <span>*</span></label>
                                    <input type="date" name="date_of_birth" className="form-control" required placeholder="Date of Birth" 
                                    onChange={handleChange} defaultValue={details.date_of_birth && details.date_of_birth }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Gender <span>*</span></label>
                                    <select className="form-control form-select" name="gender" id="gender" required 
                                    onChange={handleChange} defaultValue={details.gender && details.gender} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">State of Origin <span>*</span></label>
                                    <select className="form-control form-select" name="state_of_origin" id="state_of_origin" required 
                                    onChange={handleChange} defaultValue={details.state_of_origin && details.state_of_origin} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {states && states.map((item, i) => (
                                            <option key={i} value={item.label}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Nationality <span>*</span></label>
                                    <select className="form-control form-select" name="nationality" id="nationality" required 
                                    onChange={handleChange} defaultValue={details.nationality && details.nationality} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="nigerian">Nigerian</option>
                                        <option value="expatriate">Expatriate</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Marital Status <span>*</span></label>
                                    <select className="form-control form-select" name="marital_status" id="marital_status" required 
                                    onChange={handleChange} defaultValue={details.marital_status && details.marital_status} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="single">Single</option>
                                        <option value="married">Married</option>
                                        <option value="divorced">Divorced</option>
                                        <option value="separated">Separated</option>
                                    </select>
                                </div>
                            </div>
                            {isCanEdit && 
                                <div className="row">
                                    <div className="col-md-12 form-group">
                                        <button 
                                            type="submit" 
                                            className="btn" 
                                            disabled={loading}
                                            onClick={handleUpdatePersonal} >Save Changes</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div> 
            
            <div id="bankModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">UPDATE BANK INFORMATION</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Bank Name <span>*</span></label>
                                    <input type="text" name="bank_name" className="form-control" required placeholder="Bank Name" 
                                    onChange={handleChange} defaultValue={details.bank_name && details.bank_name }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Bank Account Number <span>*</span></label>
                                    <input type="text" name="account_number" className="form-control" required placeholder="Bank Account Number" 
                                    onChange={handleChange} defaultValue={details.account_number && details.account_number } disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Bank Account Type <span>*</span></label>
                                    <input type="text" name="account_type" className="form-control" required placeholder="Bank Account Type" 
                                    onChange={handleChange} defaultValue={details.account_type && details.account_type } disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Bank Branch <span>*</span></label>
                                    <input type="text" name="bank_address" className="form-control" required placeholder="Bank Branch"
                                    onChange={handleChange} defaultValue={details.bank_address && details.bank_address } disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">ETCC PIN </label>
                                    <input type="text" name="etcc_pin" className="form-control" placeholder="ETCC PIN" 
                                    onChange={handleChange} defaultValue={details.etcc_pin && details.etcc_pin } disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">PFA Name <span>*</span></label>
                                    <input type="text" name="pfa_name" className="form-control" required placeholder="Pension Fund Administrator Name" 
                                    onChange={handleChange} defaultValue={details.pfa_name && details.pfa_name } disabled={loading} />
                                </div>

                                <div className="col-md-6 form-group">
                                    <label className="control-label">PFA Account Number <span>*</span></label>
                                    <input type="text" name="pfa_account" className="form-control" required placeholder="PFA Account Number" 
                                    onChange={handleChange} defaultValue={details.pfa_account && details.pfa_account } disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">PFA PIN <span>*</span></label>
                                    <input type="text" name="pfa_pin" className="form-control" required placeholder="PFA Pin" 
                                    onChange={handleChange} defaultValue={details.pfa_pin && details.pfa_pin } disabled={loading} />
                                </div>
                            </div>
                            {isCanEdit && 
                                <div className="row">
                                    <div className="col-md-12 form-group">
                                        <button 
                                            type="submit" 
                                            className="btn" 
                                            disabled={loading}
                                            onClick={handleUpdateBank} >Save Changes</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div> 

            <div id="nokModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">UPDATE NEXT OF KIN INFORMATION</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Name <span>*</span></label>
                                    <input type="text" name="nok_name" className="form-control" required placeholder="Name" 
                                    onChange={handleChange} defaultValue={details.nok_name && details.nok_name }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Relationship <span>*</span></label>
                                    <input type="text" name="nok_relationship" className="form-control" required placeholder="Relationship" 
                                    onChange={handleChange} defaultValue={details.nok_relationship && details.nok_relationship } disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Address <span>*</span></label>
                                    <input type="text" name="nok_address" className="form-control" required placeholder="Address" 
                                    onChange={handleChange} defaultValue={details.nok_address && details.nok_address } disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Phone <span>*</span></label>
                                    <input type="text" name="nok_phone" className="form-control" required placeholder="Phone"
                                    onChange={handleChange} defaultValue={details.nok_phone && details.nok_phone } disabled={loading} />
                                </div>
                            </div>
                            {isCanEdit && 
                                <div className="row">
                                    <div className="col-md-12 form-group">
                                        <button 
                                            type="submit" 
                                            className="btn" 
                                            disabled={loading}
                                            onClick={handleUpdateNOK} >Save Changes</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div> 

            <div id="refModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">UPDATE GUARANTOR INFORMATION</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Name <span>*</span></label>
                                    <input type="text" name="reference_name" className="form-control" required placeholder="Name" 
                                    onChange={handleChange} defaultValue={details.reference_name && details.reference_name }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Address <span>*</span></label>
                                    <input type="text" name="reference_address" className="form-control" required placeholder="Address" 
                                    onChange={handleChange} defaultValue={details.reference_address && details.reference_address } disabled={loading} />
                                </div>
                            </div>
                            {isCanEdit && 
                                <div className="row">
                                    <div className="col-md-12 form-group">
                                        <button 
                                            type="submit" 
                                            className="btn" 
                                            disabled={loading}
                                            onClick={handleUpdateRef} >Save Changes</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div> 


            </> }
        </>
    );
}
